/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="11.93"
        height="6.68"
        viewBox="0 0 11.93 6.68"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m6 1.41 5.22 5.25.71-.7L6 0 0 5.97l.7.71L6 1.41z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'ChevronUpIcon';

export default Icon;
